import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ_ITEMS } from "./data";
import { LANDING } from "@/constants/testIds";

export default function FAQSection() {
  return (
    <section className="py-28 bg-[#f3ecf7]">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-4xl lg:text-[52px] text-[#1f1430] leading-[1.1]">
            O que as mães perguntam
            <span className="block text-[#a78bfa] font-medium mt-3">
              antes de entrar na Jornada.
            </span>
          </h2>
        </motion.div>

        <Accordion
          type="single"
          collapsible
          data-testid={LANDING.faqAccordion}
          className="space-y-4"
        >
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`${LANDING.faqItem}-${i}`}
              className="rounded-2xl border border-[#e0d4ec] bg-white/80 px-6 lg:px-8 backdrop-blur-sm hover:border-violet-400/40 data-[state=open]:border-violet-400/50 data-[state=open]:bg-white transition-all duration-300 overflow-hidden"
            >
              <AccordionTrigger className="text-left text-[#1f1430] font-semibold text-[16px] lg:text-[17px] hover:no-underline py-6 leading-snug">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#4a3a5e] text-[15px] leading-[1.75] pb-6 pr-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
